var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.needFormat(_vm.type) ? 'ComplexTree' : 'NormalTree',{tag:"Component",attrs:{"name":_vm.name,"value":_vm.value,"type":_vm.type,"line":_vm.line,"showIndex":_vm.showIndex,"needComma":_vm.needComma,"level":_vm.level,"lineType":_vm.lineType,"lastLineType":_vm.lastLineType,"lastLine":_vm.lastLine}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-36d076aa","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vue-json-compare/src/tree.vue
// module id = null
// module chunks = 